// extracted by mini-css-extract-plugin
module.exports = {"noDataNote":"PolicyLiabilityComponent_noDataNote__249YO"};